import React from 'react';
import { CalendarDay } from './CalendarDay';
import { isWeekend, formatLocalISO } from '../utils/date-utils';

export const CalendarGrid = ({
  viewDate,
  computedMinDate,
  computedMaxDate,
  reservedSet,
  holidaySet,
  todayIso,
  onDateSelect
}) => {
  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const monthDays = new Date(year, month + 1, 0).getDate();
  const firstWeekday = new Date(year, month, 1).getDay();

  const minIso = formatLocalISO(computedMinDate);
  const maxIso = formatLocalISO(computedMaxDate);

  const days = [];

  for (let j = 0; j < firstWeekday; j++) {
    days.push(<div key={`pad-${j}`} className="day empty" />);
  }

  for (let i = 1; i <= monthDays; i++) {
    const date = new Date(year, month, i);
    const isoLocal = formatLocalISO(date);

    const weekend = isWeekend(date);
    const isHoliday = holidaySet.has(isoLocal);
    const isReserved = reservedSet.has(isoLocal);
    const isPast = isoLocal < todayIso;
    const isBeforeMin = isoLocal <= minIso;
    const isAfterMax = maxIso ? (isoLocal > maxIso) : false;

    const isDisabled = weekend || isHoliday || isReserved || isPast || isBeforeMin || isAfterMax;

    const classes = ['day'];
    if (weekend) classes.push('blocked');
    if (isHoliday) classes.push('blocked');
    if (!isHoliday && isReserved) classes.push('reserved');
    if (isPast) classes.push('past');
    if (isBeforeMin) classes.push('before-min');
    if (isAfterMax) classes.push('after-max');

    let titleText = '';
    // if (isDisabled) {
    //   if (isReserved && !isHoliday) titleText = 'Reserved';
    //   else if (isAfterMax) titleText = `Not selectable — beyond ${maxIso}`;
    //   else if (isHoliday) titleText = 'Holiday — not selectable';
    //   else titleText = 'Not selectable';
    // } else {
    //   titleText = `Select ${isoLocal}`;
    // }

    titleText = `Select ${isoLocal}`;

    days.push(
      <CalendarDay
        key={isoLocal}
        date={i}
        isoLocal={isoLocal}
        isDisabled={isDisabled}
        classes={classes}
        titleText={titleText}
        onDateSelect={onDateSelect}
      />
    );
  }

  return <div className="days">{days}</div>;
};
